import $axios from '../config.js'
import {
  _post
} from '../request.js'

// 公共字典url
const GET_DICTIONARY = '/auth/dictionaries/findByParentId'

// 公共无登录限制字典url
const GET_PUBLIC_DICTIONARY = 'auth/public/findByParentId'

// download权限字典url
const GET_DOWNLOAD_AUTH = '/manage/resource/findDownAuthority'

const GET_TRADEFUNCTION_AUTH = '/auth/public/trade/formulationFunctions'

const GET_FUNCTION_AUTH = '/auth/public/tradeFunctions'

const GET_ECOSTATUS_AUTH = '/auth/public/ecoStatuses'

const GET_FORMDELIVERY_AUTH = '/app/trade/tradeFormDelivery'

const GET_MAINGROUP_AUTH = '/auth/public/mainGroups'

const GET_APPLICATIONS = '/app/trade/getApplications'

const GET_TRADE_COUNTRY = '/app/trade/allTradeCountries'

const GET_CONSUMER_BENEFITS = '/auth/public/consumerBenefits'

const GET_APPROVE_USER = '/auth/user/searchApproveUserList'

const GET_SUBMIT_BY = '/auth/user/searchUserList'

const GET_USERLIST_NAME = '/auth/user/searchUserListByName'

const GET_USERLIST_EMAIL = '/auth/user/searchApproveUserListByEmail'

// segment字典
const GET_SEGMENT = '/auth/public/segment_list'

const GET_CATEGORY = '/auth/public/get_goodsMarketCategory'

// 获取资源列表
const GET_RESOURCE = '/manage/resource/findFilterResourceList'

// 获取用户状态
const GET_USER_STATUS = '/auth/user/newSearchUserList'

// 获取message搜索建议
const GET_MESSAGE_SUGGEST = '/auth/message/titles'

const GET_PREFERENCE = '/auth/pushModuleCategoryConfig/findFilter'
const GET_GOODS_FORMS = '/auth/public/get_goodsForms'

export const getDictionary = (id, isSort) => {
  return $axios({
    url: GET_DICTIONARY,
    method: 'post',
    data: {
      parentId: id,
      sort: id === 220 ? 'sort' : isSort ? 'first' : undefined
    }
  })
}

export const getPublicDictionary = (id, isSort) => {
  return $axios({
    url: GET_PUBLIC_DICTIONARY,
    method: 'post',
    data: {
      parentId: id,
      sort: isSort ? 'first' : undefined
    }
  })
}

export const getResource = ({resourceModule, functionType}) => {
  return $axios({
    url: GET_RESOURCE,
    method: 'post',
    data: {resourceModule, functionType}
  })
}

// 字典api

// 获取status字典
export function getDicByStatus () {
  return getDictionary(1)
}
// 获取type字典
export function getDicByType () {
  return getDictionary(131)
}
// 获取region字典
export function getDicByRegion () {
  return getDictionary(5)
}
// 获取position字典 id：83 ，id:94
export function getDicByPositiona () {
  return getDictionary(83)
}
export function getDicByPositionb () {
  return getDictionary(94)
}
// 获取country字典
export function getDicByCountry (isSort) {
  return getDictionary(134, isSort)
}
// 获取year字典
export function getDicByYear () {
  return getDictionary(31)
}
// 获取language字典
export function getDicByLanguage () {
  return getDictionary(28)
}

// 获取brand position字典
export function getDicByBrandPos () {
  return getDictionary(14)
}

// 获取price position字典
export function getDicByPosPrice () {
  return getDictionary(18)
}

// 获取 module 字典
export function getDicByModule () {
  return getDictionary(262)
}
// 获取top ranking source list 字典
export function getDicBySourcelist () {
  return getDictionary(296)
}

// 获取claim source list 字典
export function getDicBySourceClaim () {
  return getDictionary(305)
}

// 获取Platfrom 字典
export function getDicByPlatfrom () {
  return getDictionary(308)
}

// 获取DataType 字典
export function getDicByDataType () {
  return getDictionary(312)
}

// 获取日志统计target 字典
export function getDicByTarget () {
  return getDictionary(315)
}

// 获取用户类型字典
// export function getDicByUserType () {
//   return getDictionary(329)
// }

// 获取download权限字典
export function getDicByDownload () {
  return $axios({
    url: GET_DOWNLOAD_AUTH,
    method: 'post'
  })
}

// 获取market segment字典
export function getDicByMarketSegment (isSort) {
  return getDictionary(333, isSort)
}

// 获取functon中 target 字典
export function getDicByFunctionTarget () {
  return getDictionary(349)
}

// 获取注册状态字典
export function getDicByRegisterStatus () {
  return getDictionary(400)
}

// 获取白名单用户类型字典
export function getDicByWhiteListUserType () {
  return getDictionary(420)
}

// 获取push 选择module字典
export function getDicByPushModule () {
  return getDictionary(611)
}

// 获取Webinar选择module字典
export function getDicByWebinarModule () {
  return getDictionary(694)
}

// 获取push 发送状态
export function getDicBySendStatus () {
  return getDictionary(605)
}
// 视频分类
export function getDicByMediaCategory () {
  return getDictionary(751)
}
// 视频语言
export function getDicByMediaLanguage () {
  return getDictionary(777)
}
// 视频segment
export function getDicByMediaSegment () {
  return getDictionary(758)
}
// 视频lifestyle
export function getDicByMediaLifestyle () {
  return getDictionary(767)
}
// 视频排序
export function getDicByMediaOrder () {
  return getDictionary(783)
}
export function getDicByMainGroup () {
  return _post(GET_MAINGROUP_AUTH)
}
// 获取 视频form
export function getGoodsForms () {
  return $axios.post(GET_GOODS_FORMS)
}
// 获取formDelivery数据
export function getDicByFormDelivery (params) {
  return _post(GET_FORMDELIVERY_AUTH, params)
}

// 获取ecoStatus数据
export function getDicByEcoStatus () {
  return _post(GET_ECOSTATUS_AUTH)
}
// 获取二级的function
export function getDicByFunction (params) {
  return _post(GET_TRADEFUNCTION_AUTH, params)
}

// 获取一级的function
export function getDicByTradeFunction (params) {
  return _post(GET_FUNCTION_AUTH, params)
}

// 获取segment字典
export function getSegmentList () {
  return _post(GET_SEGMENT, { marketSegment: 0, pid: 0 })
}

// 获取market segment字典
export function getMarketSegmentList () {
  return _post(GET_SEGMENT, { marketSegment: 1, pid: 0 })
}

// 获取applications字典
export function getApplications () {
  return _post(GET_APPLICATIONS)
}

// 获取trade country字典
export function getTradeCountry () {
  return _post(GET_TRADE_COUNTRY)
}

// 获取consumer benefits字典
export function getConsumerBenefits () {
  return _post(GET_CONSUMER_BENEFITS)
}

// 获取approver数据
export function getApproveUser (params) {
  return $axios.post(GET_APPROVE_USER, params)
}

// 获取 submit by 数据
export function getSubmitBy (params) {
  return $axios.post(GET_SUBMIT_BY, params)
}

// 根据name查用户列表
export function getUserListByName (params) {
  return $axios.post(GET_USERLIST_NAME, params)
}

// 根据email查有效用户列表
export function getUserListByEmail (params) {
  return $axios.post(GET_USERLIST_EMAIL, params)
}

// 获取 category 字典
export function getCategory () {
  return $axios.post(GET_CATEGORY)
}

// 获取  preference 字典
export function getPreference () {
  return $axios.post(GET_PREFERENCE)
}

// 获取 download 资源
export function getDownloadAuth () {
  return getResource({ functionType: 110 })
}

// 获取 display 资源
export function getDisplayAuth () {
  return getResource({ functionType: 111 })
}

// 获取 pc前端 资源
export function getFrontEndAuth () {
  return getResource({ resourceModule: 343 })
}

// 获取 角色&综合管理 资源
export function getRoleGeneralAuth () {
  return getResource({ resourceModule: 344 })
}

// 获取 数据管理 资源
export function getDataManageAuth () {
  return getResource({ resourceModule: 345 })
}

// 获取 APP管理 资源
export function getAppManageAuth () {
  return getResource({ resourceModule: 346 })
}

// 获取用户状态 默认取1000条
export function getUserStatus (data) {
  return $axios({
    url: GET_USER_STATUS,
    method: 'post',
    data
  })
}

// 获取message搜索建议
export function getMessageSuggest () {
  return $axios({
    url: GET_MESSAGE_SUGGEST,
    method: 'post'
  })
}

// 获取release Region Id 字典
export function getDicByReleaseRegion () {
  return getDictionary(369)
}

// 获取user type字典
export function getDicByUserType () {
  return getDictionary(380)
}

// 获取account中的country
export function getDicByAccountCountry () {
  return getDictionary(430)
}

// 获取account中的country  无登录限制
export function getPublicDicByAccountCountry () {
  return getPublicDictionary(430)
}

// 获取Product from Other Company模块中source筛选器
export function getDicBySource () {
  return getDictionary(453)
}

// 获取concept文件 语言
export function getDicByFileLang () {
  return getDictionary(483)
}

// 获取用户类型(内部、外部)
export function getDicByOriginUserType () {
  return getDictionary(494)
}

// 获取平台
export function getDicByPlatform () {
  return getDictionary(489)
}

// 获取下级平台（安卓/IOS）
export function getDicBySubPlatform () {
  return getDictionary(493)
}

// 获取department（安卓/IOS）
export function getDicByDepartment () {
  return getDictionary(504)
}

// 获取department（安卓/IOS）无登录限制
export function getPublicDicByDepartment () {
  return getPublicDictionary(504)
}

// 注销状态
export function getDicByDeregistration () {
  return getDictionary(500)
}

export function getSecondStatus () {
  return getDictionary(378)
}
// 获取Product Focus 字典
export function getDicByProductFocus () {
  return getDictionary(63)
}

// 获取Target Demographic Care 字典
export function getDicByTargetDemographicCare () {
  return getDictionary(58)
}


// WEBPACK FOOTER //
// ./src/axios/api/dictionary.js